import PackageForm from "features/LoyaltyPackage/presentation/pages/PackageForm";
import { PACKAGE_FORM_MODE } from "features/LoyaltyPackage/core/constants";
import { useParams } from "react-router-dom";

function PackageEditPage() {
  const { id } = useParams();

  return <PackageForm mode={PACKAGE_FORM_MODE.EDIT} periodId={id} />;
}

export default PackageEditPage;
